import { render, staticRenderFns } from "./RoundPayrate.vue?vue&type=template&id=b342144a&scoped=true&"
import script from "./RoundPayrate.vue?vue&type=script&lang=js&"
export * from "./RoundPayrate.vue?vue&type=script&lang=js&"
import style0 from "./RoundPayrate.vue?vue&type=style&index=0&id=b342144a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b342144a",
  null
  
)

export default component.exports